import APICall from "../../utils/APICalls.js";
import responseModel from "../../models/Generic/responseModel";

const ClienteServiceClient = {
    token: async function(loginUserRequest) {
        return await APICall.postAnonymous(`Cliente/Token`, loginUserRequest);
    },

    search: async function(loginUserRequest) {
        return await APICall.postAnonymous(`Cliente/Search`, loginUserRequest);
    },

    resetPassword: async function(resetPasswordRequest) {
        return await APICall.postAnonymous(`Cliente/ResetPassword`, resetPasswordRequest);
    },

    updatePassword: async function(updatePasswordRequest) {
        return await APICall.post(`Cliente/UpdatePassword`, updatePasswordRequest);
    },

    me: async function() {
        return await APICall.get(`Cliente/Me`);
    },

    getPdf: async function(document) {
        return await APICall.post(`Cliente/Pdf`, document);
    },

    getDocuments: async function(year, auth0Client) {
        let result = await APICall.get(`Cliente/Documents/${year}`, auth0Client);
        if (result !== null) {
            if ((result.succeeded === true) && (result.object)) {
                let newItems = [];
                result.object.forEach(ele => {
                    let newElement = {
                        "name": ele.name,
                        "filePath": ele.filePath
                    }
                    newItems.push(newElement);
                });
                return responseModel.responseModelOk(newItems);
            } else {
                return new responseModel(false, null, ((result.errors) && (result.errors.length)) > 0 ? result.errors[0].description : "There is a problem with the API service.");
            }               
        } else {
            return new responseModel.ResponseModelKo("There is a problem with the API service.");
        } 
    },
};

export default ClienteServiceClient;